import {WlTextInput} from "./textInput.component";

export * from './textInput.component';
export default WlTextInput;

customElements.define('wl-text-input', WlTextInput);
